<template>
  <IndexTab :product="product" />
</template>

<script lang="ts" setup>
import IndexTab from '~/components/price-assessments/IndexTab.vue'
import type { TProduct } from '~/src/types/product.ts'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  product: TProduct
}>()
</script>
